export function stringMatcherContext(ruleAttr) {
    var regex = new RegExp(ruleAttr);
    return function stringMatcher(runtimeAttr) {
        var regexMatches = regex.test(runtimeAttr);
        return regexMatches;
    };
}
